import { CITY } from "@/const/CommonConst.js";
import { isSignedContractSupply, supplySettleDays } from "../../tool/const.js";

const publicOption = [
  {
    value: "",
    label: "全部",
  },
  {
    value: "1",
    label: "是",
  },
  {
    value: "0",
    label: "否",
  },
];

const supplyStatus = [
  {
    value: "",
    label: "全部",
  },
  {
    value: "0",
    label: "禁用",
  },
  {
    value: "1",
    label: "启用",
  },
];

const isScalOptions = [
  {
    value: "",
    label: "全部",
  },
  {
    value: "0",
    label: "是",
  },
  {
    value: "1",
    label: "否",
  },
];

const settleType = [
  {
    value: "0",
    label: "全部",
  },
  {
    value: "1",
    label: "常规代采",
  },
  {
    value: "2",
    label: "先货后款",
  },
];
const supplyCharacterType = [
  {
    label: "全部",
    value: "-1",
  },
  {
    label: "常规合作商",
    value: "0",
  },
  {
    label: "买手小店",
    value: "1",
  },
  {
    label: "小店渠道商",
    value: "2",
  },
];

const storeOption = [
  {
    value: "",
    label: "全部",
  },
  {
    value: "1",
    label: "是",
  },
  {
    value: "2",
    label: "否",
  },
];

const offsiteOptions = [
  {
    value: "0",
    label: "全部",
  },
  {
    value: "1",
    label: "是",
  },
  {
    value: "2",
    label: "否",
  },
];

const billingTypeOptions = [
  {
    value: "0",
    label: "全部",
  },
  {
    value: "1",
    label: "实数单",
  },
  {
    value: "2",
    label: "排单单",
  },
];

/**
 * filter 搜索列表项配置
 * show: { Boolean } 是否展示，初始 show = true 表示默认固定展示项
 * type: { String } 类型
 * label: { String } form-item label
 * prop: { String } 字段名称
 * placeholder: { String } 占位符
 * options: { Array } 下拉选项数组
 * labelKey: { String } 下拉选项 label
 * valueKey: { String } 下拉选项 value
 * optionsName: { String } ! 下拉选项名称，用于在接口获取数据后设置对应的选项
 * event: { String } 选择输入框的 change 事件名
 * datePickerType: { String } 日期组件类型
 * datePickerFormat: { String } 日期格式
 * datePickerRangeSeparator: { String } 日期分割符
 * dateStartPlaceholder: { String } 开始日期占位符
 * dateEndPlaceholder: { String } 结束日期占位符
 */
export const filters = [
  {
    show: true,
    type: "input",
    label: "",
    prop: "supply_id",
    placeholder: "商家id",
  },
  {
    show: true,
    type: "input",
    label: "",
    prop: "supply_name",
    placeholder: "商家",
  },
  {
    show: true,
    type: "input",
    label: "",
    prop: "brand_name",
    placeholder: "品牌",
  },
  {
    show: true,
    type: "select",
    label: "",
    prop: "city",
    multiple: true,
    placeholder: "城市",
    options: [
      {
        label: "全部",
        value: "0",
      },
      ...CITY,
    ],
  },
  {
    show: true,
    type: "select",
    label: "",
    prop: "father_market_id",
    placeholder: "市场（地理位置）",
    multiple: true,
    options: [],
    optionsName: "market",
    valueKey: "key",
    event: "setChild",
  },
  {
    show: true,
    type: "select",
    label: "",
    prop: "market_id",
    placeholder: "子市场（地理位置）",
    multiple: true,
    options: [],
    valueKey: "key",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "supply_floor",
    placeholder: "楼层",
    options: [],
    optionsName: "floor",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "supply_area_id",
    placeholder: "区域",
    options: [],
    optionsName: "supply_area",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "pgid",
    placeholder: "代采组",
    multiple: true,
    options: [],
    optionsName: "pg_list",
    event: "getMemberOption",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "pg_member_id",
    placeholder: "代采员",
    multiple: true,
    options: [],
    optionsName: "memberOption",
    event: "handleChangeMember",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "dgid",
    placeholder: "次品组",
    multiple: true,
    options: [],
    optionsName: "defectiveGroupOption",
    event: "getDefectiveGroupMember",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "dg_member_id",
    placeholder: "次品员",
    multiple: true,
    options: [],
    optionsName: "defectiveGroupMemberOption",
    event: "handleChangeDefectiveGroupMember",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "refund_member_id",
    placeholder: "售后退供员",
    multiple: true,
    options: [],
    optionsName: "refundMemberOption",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "pg_id",
    placeholder: "买手组",
    options: [],
    optionsName: "pickers",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "supply_status",
    placeholder: "商家状态",
    options: supplyStatus,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "pay_method",
    placeholder: "支付方式",
    options: [
      {
        label: "全部",
        value: "",
      },
    ],
    optionsName: "pay_methods",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_self",
    placeholder: "是否自主上款",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_live",
    placeholder: "是否开通直播",
    options: publicOption,
  },
  {
    show: false,
    type: "date-picker",
    label: "创建时间：",
    prop: "create_time",
    placeholder: "",
    datePickerType: "daterange",
    datePickerFormat: "yyyy-MM-dd",
    datePickerRangeSeparator: "至",
    dateStartPlaceholder: "开始日期",
    dateEndPlaceholder: "结束日期",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_baob",
    placeholder: "是否开通爆版",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_order_ability",
    placeholder: "是否爆版开单",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "special_sale",
    placeholder: "能否参与特价销售",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "as_plan",
    placeholder: "售后提前代采",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "all_rebuild_plan",
    placeholder: "重新代采计划全量生成",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_platform",
    placeholder: "是否平台化商家",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "no_reason_return",
    placeholder: "是否开通退货服务",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "refund_model",
    placeholder: "退货模式",
    options: [
      {
        label: "全部",
        value: "",
      },
    ],
    optionsName: "refund_models",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "reject_accept",
    placeholder: "退换货是否接收",
    options: publicOption,
  },
  {
    show: false,
    type: "input",
    label: "",
    prop: "company_name",
    placeholder: "公司名",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "bind_type",
    placeholder: "买手绑定关系",
    options: [
      {
        label: "全部",
        value: "",
      },
      {
        label: "核心档口",
        value: "1",
      },
      {
        label: "公共档口",
        value: "2",
      },
    ],
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_ka",
    placeholder: "是否KA",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_strength",
    placeholder: "是否实力档口",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "billing_type",
    placeholder: "开单方式",
    options: billingTypeOptions,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_offsite",
    placeholder: "异地配货",
    options: offsiteOptions,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "settle_type",
    placeholder: "交易方式",
    options: settleType,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_lower_enter",
    placeholder: "是否轻入驻",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "settle_days",
    placeholder: "结算周期",
    options: supplySettleDays,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_signed_contract",
    placeholder: "是否签约商家",
    options: isSignedContractSupply,
  },
  {
    show: false,
    type: "input",
    label: "",
    prop: "payee_name",
    placeholder: "收款人名称",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_authentication",
    placeholder: "是否已鉴权",
    options: storeOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_all_style",
    placeholder: "是否全类目上款",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_benchmarking",
    placeholder: "是否标杆商家",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "sale_level",
    placeholder: "商家等级",
    options: [
      {
        label: "全部",
        value: "",
      },
    ],
    optionsName: "sale_levels",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "update_sale_level",
    placeholder: "商家等级(手改)",
    options: [
      {
        label: "全部",
        value: "",
      },
    ],
    optionsName: "sale_levels",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "follower_admin_id",
    placeholder: "商家运营跟进人",
    options: [
      {
        label: "全部",
        value: "0",
      },
    ],
    optionsName: "followerOption",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "expander",
    placeholder: "商家拓展跟进人",
    options: [
      {
        label: "全部",
        value: "0",
      },
    ],
    optionsName: "followerOption",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_scal",
    placeholder: "是否可刷单",
    options: isScalOptions,
  },
  {
    show: false,
    type: "input",
    label: "",
    prop: "baobmobile",
    placeholder: "爆版手机账号",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "self_operation_special",
    placeholder: "是否自运营专场",
    options: publicOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_sign_pingan_agreement",
    placeholder: "是否已签署结算通",
    options: [
      {
        label: "全部",
        value: "",
      },
      {
        label: "否",
        value: "2",
      },
      {
        label: "是",
        value: "1",
      },
    ],
  },
  // {
  //   show: false,
  //   type: "select",
  //   label: "",
  //   prop: "take_stock_on_plan",
  //   placeholder: "按计划点货",
  //   options: [
  //     {
  //       label: "全部",
  //       value: "",
  //     },
  //     {
  //       label: "否",
  //       value: "2",
  //     },
  //     {
  //       label: "是",
  //       value: "1",
  //     },
  //   ],
  // },
  {
    show: true,
    type: "select",
    label: "",
    prop: "goods_exempt_examine",
    placeholder: "商品发布/编辑免审",
    options: [
      {
        label: "全部",
        value: "",
      },
      {
        label: "否",
        value: "0",
      },
      {
        label: "是",
        value: "1",
      },
    ],
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "supply_character",
    placeholder: "商家性质",
    options: supplyCharacterType,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "supply_level",
    placeholder: "档口线下实力分级",
    options: [],
    optionsName: "level_options",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_return_profit",
    placeholder: "是否参与折扣让利",
    options: [
      {
        label: "是",
        value: "1",
      },
      {
        label: "否",
        value: "2",
      },
    ],
  },
  {
    show: true,
    type: "select",
    label: "",
    prop: "period_profit",
    placeholder: "折扣让利账期",
    options: [
      {
        label: "全部",
        value: "",
      },
      {
        label: "按天生成",
        value: "2",
      },
      {
        label: "按月生成",
        value: "1",
      },
    ],
  },
  {
    show: true,
    type: "select",
    label: "",
    prop: "clearing_form",
    placeholder: "折扣让利账单结算方式",
    options: [
      {
        label: "全部",
        value: "",
      },
      {
        label: "代采单抵扣",
        value: "1",
      },
      {
        label: "账单支付",
        value: "2",
      },
    ],
  },
  {
    show: false,
    type: "input",
    label: "",
    prop: "pre_storage_admin",
    placeholder: "前置仓跟进人",
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_participation_dispense",
    placeholder: "是否参与小店分发",
    options: storeOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "is_auto_ded",
    placeholder: "是否自动用抵扣商品",
    options: storeOption,
  },
  {
    show: false,
    type: "select",
    label: "",
    prop: "attributable_market_id",
    placeholder: "业绩归属市场",
    options: [],
  },
];

/**
 * column 表格列配置
 * show: { Boolean } 是否展示
 * label: { String } el-table-column label
 * prop: { String } 字段名称
 * width: { String } 宽度
 */
export const tableColumns = [
  {
    show: true,
    prop: "supply_id",
    label: "商家id",
  },
  {
    show: true,
    prop: "supply_city",
    label: "城市",
  },
  {
    show: true,
    prop: "father_market",
    label: "市场",
  },
  {
    show: true,
    prop: "market",
    label: "子市场",
  },
  {
    show: true,
    prop: "supply_name",
    label: "商家名称",
    width: "100",
  },
  {
    show: true,
    prop: "brands",
    label: "品牌",
  },
  {
    show: true,
    prop: "supply_floor",
    label: "楼层",
  },
  {
    show: true,
    prop: "supply_area",
    label: "区域",
  },
  {
    show: true,
    prop: "supplier_num",
    label: "档口号",
  },
  {
    show: true,
    prop: "picker_group_member_name",
    label: "绑定的买手",
    width: "100",
  },
  {
    show: true,
    prop: "bind_type",
    label: "买手绑定关系",
    width: "120",
  },
  {
    show: true,
    prop: "pgname",
    label: "代采组",
  },
  {
    show: true,
    prop: "member",
    label: "代采员",
  },
  {
    show: true,
    prop: "dggroup",
    label: "次品组",
  },
  {
    show: true,
    prop: "dgmember",
    label: "次品员",
  },
  {
    show: true,
    prop: "refund_member_name",
    label: "售后退供员",
    width: "100",
  },
  {
    show: true,
    prop: "supply_supply_status",
    label: "状态",
  },
  {
    show: false,
    prop: "supply_character_formal",
    label: "商家性质",
  },
  {
    show: true,
    prop: "is_platform",
    label: "是否平台化",
    width: "100",
  },
  {
    show: false,
    prop: "company_name",
    label: "公司名",
  },
  {
    show: false,
    prop: "supply_pgroup_relat",
    label: "绑定的买手组",
    width: "120",
  },
  {
    show: false,
    prop: "follower",
    label: "商家运营跟进人",
    width: "120",
  },
  {
    show: false,
    prop: "expander",
    label: "商家拓展跟进人",
    width: "120",
  },
  {
    show: false,
    prop: "pg_name",
    label: "买手组",
  },
  {
    show: false,
    prop: "picker_member_name",
    label: "买手",
  },
  {
    show: false,
    prop: "supply_developer_admin",
    label: "商家开发人",
    width: "120",
  },
  {
    show: false,
    prop: "special_sale",
    label: "是否参与特价销售",
    width: "140",
  },
  {
    show: false,
    prop: "is_benchmarking",
    label: "是否标杆",
  },
  {
    show: false,
    prop: "is_ka",
    label: "是否KA",
  },
  {
    show: false,
    prop: "no_reason_return",
    label: "是否开通退货服务",
    width: "140",
  },
  {
    show: false,
    prop: "refund_model",
    label: "退货模式",
  },
  {
    show: false,
    prop: "sale_level",
    label: "商家销售等级",
    width: "140",
  },
  {
    show: false,
    prop: "update_sale_level",
    label: "商家销售等级(手改)",
    width: "160",
  },
  {
    show: false,
    prop: "season",
    label: "擅长季节",
  },
  {
    show: false,
    prop: "age_group",
    label: "适合年龄段",
    width: "100",
  },
  {
    show: false,
    prop: "supply_grade",
    label: "档次",
  },
  {
    show: false,
    prop: "cat_ids",
    label: "擅长品类",
  },
  {
    show: false,
    prop: "styles",
    label: "主风格",
  },
  {
    show: false,
    prop: "second_styles",
    label: "副风格",
  },
  {
    show: false,
    prop: "disable_count",
    label: "禁用次数",
  },
  {
    show: false,
    prop: "disable_remark",
    label: "最近禁用备注",
    width: "120",
  },
  {
    show: false,
    prop: "self_operation_special",
    label: "是否自运营专场",
    width: "140",
  },
  {
    show: false,
    prop: "supply_is_strength",
    label: "是否实力档口",
    width: "120",
  },
  {
    show: false,
    prop: "billing_type_text",
    label: "开单方式",
    width: "120",
  },
  {
    show: false,
    prop: "is_offsite_text",
    label: "异地配货",
    width: "120",
  },
  {
    show: false,
    prop: "supply_is_scal",
    label: "是否可刷单",
    width: "100",
  },
  {
    show: false,
    prop: "limit_day",
    label: "锁定排单天数",
    width: "120",
  },
  {
    show: false,
    prop: "supply_action_value",
    label: "商品默认活跃值",
    width: "140",
  },
  {
    show: false,
    prop: "create_admin",
    label: "创建人",
  },
  {
    show: false,
    prop: "create_time",
    label: "创建时间",
  },
  // {
  //   show: false,
  //   prop: "take_stock_on_plan",
  //   label: "按计划点货",
  // },
  {
    show: false,
    prop: "is_sign_pingan_agreement",
    label: "是否已签署结算通",
  },
  {
    show: false,
    prop: "supply_settle_type",
    label: "交易方式",
  },
  {
    show: false,
    prop: "is_authentication",
    label: "是否已鉴权",
    width: "160",
  },
  {
    show: false,
    prop: "supply_permissions_pay_method",
    label: "支付方式",
  },
  {
    show: false,
    prop: "as_plan",
    label: "售后提前代采",
    width: "120",
  },
  {
    show: false,
    prop: "all_rebuild_plan",
    label: "重新代采计划全量生成",
    width: "160",
  },
  {
    show: false,
    prop: "reject_accept",
    label: "退换货是否需接收",
    width: "140",
  },
  {
    show: false,
    prop: "settle_days_text",
    label: "结算周期",
  },
  {
    show: false,
    prop: "remark",
    label: "备注",
  },
  {
    show: false,
    prop: "is_return_profit_format",
    label: "是否参与折扣让利",
  },
  {
    show: false,
    prop: "period_profit_format",
    label: "折扣让利账期",
  },
  {
    show: false,
    prop: "clearing_form_format",
    label: "折扣让利账单结算方式",
  },
  {
    show: false,
    prop: "pre_storage_admin_name",
    label: "前置仓跟进人",
  },
  {
    show: false,
    prop: "is_auto_ded_text",
    label: "是否自动用抵扣商品",
  },
  {
    show: false,
    prop: "attributable_market_name",
    label: "业绩归属市场",
  },
  {
    show: true,
    prop: "attributable_market_sub_name",
    label: "业绩归属细分市场",
  },
];

export const customFilters = [
  {
    active: false,
    label: "楼层",
    value: "supply_floor",
  },
  {
    active: false,
    label: "区域",
    value: "supply_area_id",
  },
  {
    active: false,
    label: "代采组",
    value: "pgid",
  },
  {
    active: false,
    label: "代采员",
    value: "pg_member_id",
  },
  {
    active: false,
    label: "次品组",
    value: "dgid",
  },
  {
    active: false,
    label: "次品员",
    value: "dg_member_id",
  },
  {
    active: false,
    label: "售后退供员",
    value: "refund_member_id",
  },
  {
    active: false,
    label: "买手组",
    value: "pg_id",
  },
  {
    active: false,
    label: "商家状态",
    value: "supply_status",
  },
  {
    active: false,
    label: "支付方式",
    value: "pay_method",
  },
  {
    active: false,
    label: "是否自主上款",
    value: "is_self",
  },
  {
    active: false,
    label: "是否开通直播",
    value: "is_live",
  },
  {
    active: false,
    label: "创建时间",
    value: "create_time",
  },
  {
    active: false,
    label: "是否开通爆版",
    value: "is_baob",
  },
  {
    active: false,
    label: "是否爆版开单",
    value: "is_order_ability",
  },
  {
    active: false,
    label: "能否参与特价销售",
    value: "special_sale",
  },
  {
    active: false,
    label: "售后提前代采",
    value: "as_plan",
  },
  {
    active: false,
    label: "重新代采计划全量生成",
    value: "all_rebuild_plan",
  },
  {
    active: false,
    label: "是否平台化商家",
    value: "is_platform",
  },
  {
    active: false,
    label: "是否开通退货服务",
    value: "no_reason_return",
  },
  {
    active: false,
    label: "退货模式",
    value: "refund_model",
  },
  {
    active: false,
    label: "退换货是否接收",
    value: "reject_accept",
  },
  {
    active: false,
    label: "公司名",
    value: "company_name",
  },
  {
    active: false,
    label: "买手绑定关系",
    value: "bind_type",
  },
  {
    active: false,
    label: "是否KA",
    value: "is_ka",
  },
  {
    active: false,
    label: "是否实力档口",
    value: "is_strength",
  },
  {
    active: false,
    label: "开单方式",
    value: "billing_type",
  },
  {
    active: false,
    label: "异地配货",
    value: "is_offsite",
  },
  {
    active: false,
    label: "交易方式",
    value: "settle_type",
  },
  {
    active: false,
    label: "是否轻入驻",
    value: "is_lower_enter",
  },
  {
    active: false,
    label: "结算周期",
    value: "settle_days",
  },
  {
    active: false,
    label: "是否签约商家",
    value: "is_signed_contract",
  },
  {
    active: false,
    label: "收款人名称",
    value: "payee_name",
  },
  {
    active: false,
    label: "是否已鉴权",
    value: "is_authentication",
  },
  {
    active: false,
    label: "是否全类目上款",
    value: "is_all_style",
  },
  {
    active: false,
    label: "是否标杆商家",
    value: "is_benchmarking",
  },
  {
    active: false,
    label: "商家等级",
    value: "sale_level",
  },
  {
    active: false,
    label: "商家等级(手改)",
    value: "update_sale_level",
  },
  {
    active: false,
    label: "商家运营跟进人",
    value: "follower_admin_id",
  },
  {
    active: false,
    label: "商家拓展跟进人",
    value: "expander",
  },
  {
    active: false,
    label: "是否可刷单",
    value: "is_scal",
  },
  {
    active: false,
    label: "爆版手机账号",
    value: "baobmobile",
  },
  {
    active: false,
    label: "是否自运营专场",
    value: "self_operation_special",
  },
  {
    active: false,
    label: "商家性质",
    value: "supply_character",
  },
  {
    active: false,
    label: "档口实力等级分级",
    value: "supply_level",
  },
  {
    active: false,
    label: "是否参与折扣让利",
    value: "is_return_profit",
  },
  {
    active: false,
    label: "折扣让利账期",
    value: "period_profit",
  },
  {
    active: false,
    label: "折扣让利账单结算方式",
    value: "clearing_form",
  },
  {
    active: false,
    label: "前置仓跟进人",
    value: "pre_storage_admin",
  },
  {
    active: false,
    label: "是否参与小店分发",
    value: "is_participation_dispense",
  },
  {
    active: false,
    label: "是否已签署结算通",
    value: "is_sign_pingan_agreement",
  },
  // {
  //   active: false,
  //   label: "按计划点货",
  //   value: "take_stock_on_plan",
  // },
  {
    active: false,
    label: "是否自动用抵扣商品",
    value: "is_auto_ded",
  },
  {
    active: false,
    label: "业绩归属市场",
    value: "attributable_market_id",
  },
];

export const customTableColumns = [
  {
    active: false,
    label: "公司名",
    value: "company_name",
  },
  {
    active: false,
    label: "绑定的买手组",
    value: "supply_pgroup_relat",
  },
  {
    active: false,
    label: "商家运营跟进人",
    value: "follower",
  },
  {
    active: false,
    label: "商家拓展跟进人",
    value: "expander",
  },
  {
    active: false,
    label: "买手组",
    value: "pg_name",
  },
  {
    active: false,
    label: "买手",
    value: "picker_member_name",
  },
  {
    active: false,
    label: "商家开发人",
    value: "supply_developer_admin",
  },
  {
    active: false,
    label: "是否参与特价销售",
    value: "special_sale",
  },
  {
    active: false,
    label: "是否标杆",
    value: "is_benchmarking",
  },
  {
    active: false,
    label: "是否KA",
    value: "is_ka",
  },
  {
    active: false,
    label: "是否开通退货服务",
    value: "no_reason_return",
  },
  {
    active: false,
    label: "退货模式",
    value: "refund_model",
  },
  {
    active: false,
    label: "商家销售等级",
    value: "sale_level",
  },
  {
    active: false,
    label: "商家销售等级(手改)",
    value: "update_sale_level",
  },
  {
    active: false,
    label: "擅长季节",
    value: "season",
  },
  {
    active: false,
    label: "适合年龄段",
    value: "age_group",
  },
  {
    active: false,
    label: "档次",
    value: "supply_grade",
  },
  {
    active: false,
    label: "擅长品类",
    value: "cat_ids",
  },
  {
    active: false,
    label: "主风格",
    value: "styles",
  },
  {
    active: false,
    label: "副风格",
    value: "second_styles",
  },
  {
    active: false,
    label: "禁用次数",
    value: "disable_count",
  },
  {
    active: false,
    label: "最近禁用备注",
    value: "disable_remark",
  },
  {
    active: false,
    label: "是否自运营专场",
    value: "self_operation_special",
  },
  {
    active: false,
    label: "是否实力档口",
    value: "supply_is_strength",
  },
  {
    active: false,
    label: "开单方式",
    value: "billing_type_text",
  },
  {
    active: false,
    label: "异地配货",
    value: "is_offsite_text",
  },
  {
    active: false,
    label: "是否可刷单",
    value: "supply_is_scal",
  },
  {
    active: false,
    label: "锁定排单天数",
    value: "limit_day",
  },
  {
    active: false,
    label: "商品默认活跃值",
    value: "supply_action_value",
  },
  {
    active: false,
    label: "创建人",
    value: "create_admin",
  },
  {
    active: false,
    label: "创建时间",
    value: "create_time",
  },
  // {
  //   active: false,
  //   label: "手机号",
  //   value: "supply_mobile_phone",
  // },
  // {
  //   active: false,
  //   label: "微信号",
  //   value: "supply_wechat",
  // },
  {
    active: false,
    label: "交易方式",
    value: "supply_settle_type",
  },

  {
    active: false,
    label: "支付方式",
    value: "supply_permissions_pay_method",
  },
  {
    active: false,
    label: "售后提前代采",
    value: "as_plan",
  },
  {
    active: false,
    label: "重新代采计划全量生成",
    value: "all_rebuild_plan",
  },
  {
    active: false,
    label: "退换货是否需接收",
    value: "reject_accept",
  },
  {
    active: false,
    label: "结算周期",
    value: "settle_days_text",
  },
  {
    active: false,
    label: "备注",
    value: "remark",
  },
  {
    active: false,
    label: "商家性质",
    value: "supply_character_formal",
  },
  {
    active: false,
    label: "是否参与折扣让利",
    value: "is_return_profit_format",
  },
  {
    active: false,
    label: "折扣让利账期",
    value: "period_profit_format",
  },
  {
    active: false,
    label: "折扣让利账单结算方式",
    value: "clearing_form_format",
  },
  {
    active: false,
    label: "前置仓跟进人",
    value: "pre_storage_admin_name",
  },
  // {
  //   active: false,
  //   label: "按计划点货",
  //   value: "take_stock_on_plan",
  // },
  {
    active: false,
    label: "是否已签署结算通",
    value: "is_sign_pingan_agreement",
  },
  {
    active: false,
    label: "是否已鉴权",
    value: "is_authentication",
  },
  {
    active: false,
    label: "是否自动用抵扣商品",
    value: "is_auto_ded_text",
  },
  {
    active: false,
    label: "业绩归属市场",
    value: "attributable_market_name",
  },
];



// WEBPACK FOOTER //
// ./src/pages/supply/supply-list.js